import {Logger} from 'neo-common';
import {IPlatforms, RoundEnded, RoundStarted, SpinReceived, Cashier, History, Help, Balance, GameDataLoaded} from './IPlatforms';
import {Platforms} from './Platforms';

export class PlatformPariplay implements IPlatforms {

    private messageData: Array<Object>;

    public create(): void {
        Platforms.canPlay = true;
        this.messageData = [];

        if (DEBUG) {
            this.log('create');
        }

        window.addEventListener('message', this.receiveMessage.bind(this));

        if (Platforms.pluginOrigin != null) {
            let messageObject = {
                type: 'onAppFrameReady',
                sender: Platforms.gameKey,
                lang: Platforms.lang
            };
            window.parent.postMessage(messageObject, Platforms.pluginOrigin);
        }
    }

    public loadProgress(progress: number): void {}

    public gameReady(): void {
        if (DEBUG) {
            this.log('gameReady');
        }

        if (Platforms.pluginOrigin != null) {
            let messageObject = {
                type: 'gameReady',
                sender: Platforms.gameKey,
                lang: Platforms.lang
            };
            window.parent.postMessage(messageObject, Platforms.pluginOrigin);
        }
    }

    public gameFailed(): void {}

    public gameClosing(): void {
        if (DEBUG) {
            this.log('gameClosing');
        }

        if (Platforms.pluginOrigin != null) {
            let messageObject = {
                type: 'quit',
                sender: Platforms.gameKey,
                lang: Platforms.lang
            };
            window.parent.postMessage(messageObject, Platforms.pluginOrigin);

            /*window.parent.postMessage({
                'method': 'lobby (888)'
            }, Platforms.pluginOrigin);*/
        }
    }

    public gameReloading(): void {}

    public gameChange(gameCode: string): void {}

    public error(code: string, message: string): void {}

    public clientError(id: string, message: string): void {}

    public roundInit(): void {}

    public roundStarted(args?: RoundStarted): void {
        if (DEBUG) {
            this.log('roundStarted');
        }

        if (Platforms.pluginOrigin != null) {
            if (args != null && args.totalBet != null) {
                let messageObject = {
                    type: 'roundStart',
                    sender: Platforms.gameKey,
                    lang: Platforms.lang
                };
                messageObject['data'] = {'totalBet': args.totalBet};
                window.parent.postMessage(messageObject, Platforms.pluginOrigin);
            }
        }
    }

    public spinStarted(): void {}

    public spinReceived(args?: SpinReceived): void {
        if (DEBUG) {
            this.log('spinReceived');
        }

        if (Platforms.pluginOrigin != null) {
            //roundStarted
            if (args != null && args.roundId != null && args.balance != null) {
                let messageObject_roundStarted = {
                    type: 'roundStarted',
                    sender: Platforms.gameKey,
                    lang: Platforms.lang
                };
                messageObject_roundStarted['data'] = {'id': args.roundId, 'balanceBefore': args.balance};
                window.parent.postMessage(messageObject_roundStarted, Platforms.pluginOrigin);
            }

            //ticketReceived
            if (args != null && args.totalBet != null && args.win != null && args.balance != null) {
                let messageObject_ticketReceived = {
                    type: 'ticketReceived',
                    sender: Platforms.gameKey,
                    lang: Platforms.lang
                };
                messageObject_ticketReceived['data'] = {'BetAmount': args.totalBet, 'WinAmount': args.win, 'Balance': args.balance, 'Status': {'ErrCode': 0}};
                if (this.messageData.length > 0) {
                    messageObject_ticketReceived['data']['Message'] = this.messageData;
                    this.messageData = [];
                }

                this.log(`TicketReceived - ${JSON.stringify(messageObject_ticketReceived)}`);
                window.parent.postMessage(messageObject_ticketReceived, Platforms.pluginOrigin);
            }
        }
    }

    public spinEnded(): void {}

    public roundEnded(args?: RoundEnded): void {
        if (DEBUG) {
            this.log('roundEnded');
        }

        if (Platforms.pluginOrigin != null) {
            if (args != null && args.id != null && args.win != null && args.balanceAfter != null) {
                let messageObject = {
                    type: 'roundEnded',
                    sender: Platforms.gameKey,
                    lang: Platforms.lang
                };
                messageObject['data'] = {'id': args.id, 'win': args.win, 'balanceAfter': args.balanceAfter};
                window.parent.postMessage(messageObject, Platforms.pluginOrigin);
            }
        }
    }

    public featureStarted(): void {}

    public featureInit(): void {}

    public featureFinished(): void {}

    public autoplayStarted(): void {}

    public autoplayFinished(): void {}

    public gotoCasier(args?: Cashier): void {
        if (DEBUG) {
            this.log('gotoCashier');
        }

        if (Platforms.pluginOrigin != null) {
            let messageObject = {
                type: 'cashier',
                sender: Platforms.gameKey,
                lang: Platforms.lang
            };

            if (args != null) {
                if (args.reason != null) {
                    if (messageObject['data'] == null) {
                        messageObject['data'] = {};
                    }

                    messageObject['data']['reason'] = args.reason;
                }


                if (args.target != null) {
                    if (messageObject['data'] == null) {
                        messageObject['data'] = {};
                    }

                    messageObject['data']['target'] = args.target;
                }
            }

            window.parent.postMessage(messageObject, Platforms.pluginOrigin);
        }
    }

    public gotoHistory(args?: History): void {
        if (DEBUG) {
            this.log('gotoHistory');
        }

        if (Platforms.pluginOrigin != null) {
            if (args != null && args.target != null) {
                let messageObject = {
                    type: 'history',
                    sender: Platforms.gameKey,
                    lang: Platforms.lang
                };
                messageObject['data'] = {'reason': 'RealityCheck', 'target': args.target};
                window.parent.postMessage(messageObject, Platforms.pluginOrigin);
            }
        }
    }

    public gotoHelp(args?: Help): void {
        if (DEBUG) {
            this.log('gotoHelp');
        }

        if (Platforms.pluginOrigin != null) {
            if (args != null && args.target != null) {
                let messageObject = {
                    type: 'help',
                    sender: Platforms.gameKey,
                    lang: Platforms.lang
                };
                messageObject['data'] = {'reason': 'Ribbon', 'target': args.target};
                window.parent.postMessage(messageObject, Platforms.pluginOrigin);
            }
        }
    }

    public gotoPaytable(): void {}

    public balanceUpdated(args?: Balance): void {
        if (DEBUG) {
            this.log('balanceUpdated');
        }

        if (Platforms.pluginOrigin != null) {
            if (args != null && args.amount != null) {
                let messageObject = {
                    type: 'balance',
                    sender: Platforms.gameKey,
                    lang: Platforms.lang
                };
                messageObject['data'] = {'amount': args.amount};
                window.parent.postMessage(messageObject, Platforms.pluginOrigin);
            }
        }
    }

    public sendPluginMessage(message: string): void {
        if (DEBUG) {
            this.log('sendPluginMessage');
        }

        if (message === '') {
            return;
        }

        this.messageData.push(JSON.parse(message));
    }

    public setVolume(level: number): void {}

    public quickSpinEnabled(enabled: boolean): void {}

    public bet(value: number): void {}

    public win(value: number): void {}

    public userAction(action: string, data: Object): void {}

    public gameDataLoaded(args: GameDataLoaded): void {
        if (DEBUG) {
            this.log('gameDataLoaded');
        }

        if (Platforms.pluginOrigin != null) {
            if (args != null) {
                let messageObject = {
                    type: 'gameDataLoaded',
                    sender: Platforms.gameKey,
                    lang: Platforms.lang
                };
                messageObject['data'] = {'LoadGameData': {}};

                if (args.GameName != null) {
                    messageObject['data']['LoadGameData']['GameName'] = args.GameName;
                }
                if (args.HomeUrl != null) {
                    messageObject['data']['LoadGameData']['HomeUrl'] = args.HomeUrl;
                }
                if (args.ClientToken != null) {
                    messageObject['data']['LoadGameData']['ClientToken'] = args.ClientToken;
                }
                if (args.SessionData != null) {
                    messageObject['data']['LoadGameData']['SessionData'] = args.SessionData;
                }
                if (args.CurrencyCode != null) {
                    messageObject['data']['LoadGameData']['CurrencyCode'] = args.CurrencyCode;
                }
                if (args.PlayerTokenId != null) {
                    messageObject['data']['LoadGameData']['PlayerTokenId'] = args.PlayerTokenId;

                    window.parent.postMessage(messageObject, Platforms.pluginOrigin);
                }
            }
        }
    }

    public dialogOpened(type: string, isOpen: boolean): void {}

    public fullscreen(enabled: boolean): void {}

    private receiveMessage(event: any): void {
        if (DEBUG) {
            this.log('receiveMessage');
        }

        if (event != null && event.data != null) {
            if (event.data.type != null) {
                switch (event.data.type) {
                    case 'stopAutobet':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.stopAutoplay();
                        }
                        break;
                    case 'enableSpin':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.gamePlayResume();
                        }
                        break;
                    case 'disableSpin':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.gamePlayStop(true);
                        }
                        break;
                    case 'pause':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.gamePlayStop(true);
                        }
                        break;
                    case 'resume':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.gamePlayResume();
                        }
                        break;
                }
            }
        }
    }

    private checkOrigin(origin: string): boolean {
        if (Platforms.pluginOrigin !== '*' && origin !== Platforms.pluginOrigin) {
            return false;
        }

        return true;
    }

    protected log(s: string): void {
        if (DEBUG) {
            Logger.debugGroup('Pariplay', 'Pariplay ' + s);
        }
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Platforms/PlatformPariplay.ts
 **/